import {HttpClientModule} from '@angular/common/http';
import {NgModule, ApplicationRef, APP_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgProgressModule } from '@ngx-progressbar/core';

/*
 * Platform and Environment providers/directives/pipes
 */
import {routing} from './app.routing'
// App is our top level component
import {AppComponent} from './app.component';
import {APP_RESOLVER_PROVIDERS} from './app.resolver';
import {AppState, InternalStateType} from './app.service';

// Core providers
import {CoreModule} from "./core/core.module";
import {SmartadminLayoutModule} from "./shared/layout";
import {NgxDatatableCaseComponent} from './ngx-datatable-case/ngx-datatable-case.component';
import {RouterModule} from '@angular/router';
import {ModalModule} from 'ngx-bootstrap/modal';
import {ToastrModule} from "ngx-toastr";
import {NeoInitLangService} from "./core/services/neo-init/neo-init-lang.service";

// Application wide providers
const APP_PROVIDERS = [
    ...APP_RESOLVER_PROVIDERS,
    AppState
];

type StoreType = {
    state: InternalStateType,
    restoreInputValues: () => void,
    disposeOldHosts: () => void
};

export function initConfiguration(configService: NeoInitLangService): Function {
    return () => configService.load();
}


/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,

    ],
    imports: [ // import Angular's modules
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        CoreModule,
        SmartadminLayoutModule,
        ModalModule.forRoot(),

        NgProgressModule.forRoot(),
        ToastrModule.forRoot(),

        routing
    ],
    exports: [],
    providers: [ // expose our Services and Providers into Angular's dependency injection
        // ENV_PROVIDERS,
        APP_PROVIDERS,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfiguration,
            deps: [NeoInitLangService],
            multi: true
        }
    ]
})
export class AppModule {
    constructor(public appRef: ApplicationRef, public appState: AppState) {
    }
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts